'use es6';

import { APP } from 'pricing-pages-unified-ui/constants/AuthType';
export const isAppAuthSelector = state => {
  return !!(state.config && state.config.authType === APP);
};